export function trackByRoute<T extends { route: string | string[] }>(_: number, item: T): string | string[] {
  return item.route;
}

export function trackByLabel<T extends { label: string }>(_: number, item: T): string {
  return item.label;
}

export function trackByValue(_: number, value: string): string {
  return value;
}
